import React from "react";
import AppRoutes from "./routes/AppRoutes";
import AppToaster from "./components/AppToaster";

const App: React.FC = () => {
  return (
    <div className="app">
      <main className="main-content">
        <AppRoutes />
      </main>
      {/* 7HAI-2226: without this container every toast in Bid was silent. */}
      <AppToaster />
    </div>
  );
};

export default App;
